/**
 * コミットハッシュから決定的な背景色を生成するユーティリティ
 */

/**
 * ハッシュ文字列から数値を生成
 */
function hashToNumber(hash: string): number {
  let num = 0;
  for (let i = 0; i < hash.length; i++) {
    const char = hash.charCodeAt(i);
    num = ((num << 5) - num) + char;
    num = num & num; // Convert to 32-bit integer
  }
  return Math.abs(num);
}

/**
 * コミットハッシュから背景グラデーションを生成
 * @param commitHash - Gitコミットハッシュ
 * @returns CSS グラデーション文字列
 */
export function generateBackgroundGradient(commitHash: string): string {
  // ハッシュが無効な場合はデフォルトの色を返す
  if (!commitHash || commitHash === 'unknown') {
    return 'linear-gradient(135deg, rgb(17, 24, 39) 0%, rgb(31, 41, 55) 100%)'; // gray-900 to gray-800
  }

  // ハッシュから基本となる色相を計算（0-360度）
  const hashNum = hashToNumber(commitHash);
  const hue1 = hashNum % 360;
  const hue2 = (hue1 + 30) % 360; // 30度ずらした補色に近い色
  
  // 彩度と明度を設定（暗めの背景色にするため）
  const saturation = 35 + (hashNum % 25); // 35-60%
  const lightness1 = 15 + (hashNum % 10); // 15-25%
  const lightness2 = 20 + (hashNum % 10); // 20-30%
  
  // HSLからRGBに変換
  const hsl1 = `hsl(${hue1}, ${saturation}%, ${lightness1}%)`;
  const hsl2 = `hsl(${hue2}, ${saturation}%, ${lightness2}%)`;
  
  // グラデーション角度も変化させる
  const angle = 120 + (hashNum % 120); // 120-240度
  
  return `linear-gradient(${angle}deg, ${hsl1} 0%, ${hsl2} 100%)`;
}

/**
 * コミットハッシュから単色の背景色を生成（フォールバック用）
 * @param commitHash - Gitコミットハッシュ
 * @returns CSS 色文字列
 */
export function generateBackgroundColor(commitHash: string): string {
  // ハッシュが無効な場合はデフォルトの色を返す
  if (!commitHash || commitHash === 'unknown') {
    return 'rgb(17, 24, 39)'; // gray-900
  }

  const hashNum = hashToNumber(commitHash);
  const hue = hashNum % 360;
  const saturation = 30 + (hashNum % 20); // 30-50%
  const lightness = 18 + (hashNum % 7); // 18-25%
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}